import { cn } from '@/src/lib/utils';
import { useNavigate } from 'react-router-dom';

interface NavBarProps {
    navItems: {
        name: string;
        route: string;
        current: boolean;
    }[];
}

export default function NavBar({ navItems }: NavBarProps) {
    const navigate = useNavigate();

    return (
        <nav aria-label="Progress ">
            <ol className="space-y-4 md:flex md:space-x-8 md:space-y-0 hidden md:block">
                {navItems.map((navItem) => (
                    <li key={navItem.name} className={cn('md:flex-1')}>
                        {navItem.current ? (
                            // eslint-disable-next-line
                            <a className="group flex flex-col border-dark dark:border-gray-100 hover:border-gray-900 dark:hover:border-gray-100 border-l-0 border-t-4 pb-0 pl-0 pt-4 cursor-pointer">
                                <span className="text-sm font-medium monospace-font text-black dark:text-white cursor-pointer">
                                    {navItem.name}
                                </span>
                            </a>
                        ) : (
                            // eslint-disable-next-line
                            <a
                                className="group flex flex-col border-[#333333] dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 border-l-0 border-t-4 pb-0 pl-0 pt-4 cursor-pointer"
                                onClick={() => navigate(navItem.route)}
                            >
                                <span className="text-sm font-medium  monospace-font text-gray-500 dark:text-gray-400 group-hover:text-gray-700 dark:group-hover:text-gray-600">
                                    {navItem.name}
                                </span>
                            </a>
                        )}
                    </li>
                ))}
            </ol>
            <div className="block md:hidden flex flex-row">
                {/*<div className="flex justify-between">
                    <div className="flex items-center">
                        <span className="text-sm font-medium monospace-font text-black dark:text-white">
                            {steps[0].name}
                        </span>
                    </div>
                    <span className="text-sm font-medium monospace-font text-gray-500 dark:text-gray-400">
                        Step{' '}
                        {steps.findIndex((step) => step.status === 'current') +
                            1}{' '}
                        of {steps.length}
                    </span>
                </div>*/}
                {navItems.map((navItem, index) => {
                    return (
                        <>
                            {index > 0 && (
                                <div className="pl-[0px] w-10 text-center">
                                    /
                                </div>
                            )}
                            <div>
                                {navItem.current ? (
                                    // eslint-disable-next-line
                                    <a onClick={() => navigate(navItem.route)}>
                                        <span className="text-xs font-medium monospace-font text-black dark:text-white cursor-pointer">
                                            {navItem.name}
                                        </span>
                                    </a>
                                ) : (
                                    // eslint-disable-next-line
                                    <a onClick={() => navigate(navItem.route)}>
                                        <span className="text-xs font-medium monospace-font text-gray-500 dark:text-gray-400">
                                            {navItem.name}
                                        </span>
                                    </a>
                                )}
                            </div>
                        </>
                    );
                })}
            </div>
        </nav>
    );
}
